const DisablePaymentsPlugin = {
  install(Vue) {
    const hasToDisablePayments = process.env.VUE_APP_DISABLE_PAYMENTS === 'true';

    Vue.prototype.$hasToDisablePayments = hasToDisablePayments;
  },
};

export default DisablePaymentsPlugin;
